import "./bulbs.css";

const bulbs = [
    // blue orbs
    { color: "var(--bulb-blue)", size: 520, top: "5%",  left: "10%",  anim: "bulb-a", dur: "28s", delay: "0s"   },
    { color: "var(--bulb-blue)", size: 400, top: "55%", left: "65%",  anim: "bulb-b", dur: "34s", delay: "-8s"  },
    { color: "var(--bulb-blue)", size: 300, top: "75%", left: "20%",  anim: "bulb-c", dur: "22s", delay: "-14s" },
    // yellow orbs
    { color: "var(--bulb-yellow)", size: 440, top: "15%", left: "70%", anim: "bulb-b", dur: "30s", delay: "-5s"  },
    { color: "var(--bulb-yellow)", size: 360, top: "60%", left: "40%", anim: "bulb-a", dur: "38s", delay: "-18s" },
];

function ParticleBackground() {
    return (
        <div className="bulb-layer" aria-hidden="true">
            {bulbs.map((b, i) => (
                <div
                    key={i}
                    className="bulb"
                    style={{
                        background: b.color,
                        width: b.size,
                        height: b.size,
                        top: b.top,
                        left: b.left,
                        animationName: b.anim,
                        animationDuration: b.dur,
                        animationDelay: b.delay,
                    }}
                />
            ))}
        </div>
    );
}

export default ParticleBackground;
